import React, { useCallback } from "react";
import { useTheme } from "../../../hooks/use-theme";
import { Absence, AbsenceInput } from "../../../__generated__/graphql";
import { useI18n } from "../../../hooks/i18n-hooks";
import { Alert } from "../../Alert";
import { useAbsenceRange } from "../../../hooks/date";
import ListItem from "../../../ui_atoms/ListItem";
import IconButton from "../../IconButton";

type AbsenceListProps = {
    absences: Array<Absence | AbsenceInput>;
    onDeleteAbsenceAtIndex: (index: number) => void;
    disabled?: boolean;
};

const AbsenceList: React.FC<AbsenceListProps> = ({ absences, onDeleteAbsenceAtIndex }) => {
    const i18n = useI18n();
    const { marginSize, colors } = useTheme();

    const onActionRemove = useCallback(
        (idx: number) => {
            Alert.alert(i18n.t("absence.remove_title"), i18n.t("absence.remove_info"), [
                {
                    text: i18n.t("cancel"),
                    style: "cancel",
                },
                {
                    text: i18n.t("absence.remove_action"),
                    onPress: () => onDeleteAbsenceAtIndex(idx),
                    style: "destructive",
                },
            ]);
        },
        [i18n, onDeleteAbsenceAtIndex],
    );

    const absenceRange = useAbsenceRange();

    return absences?.map((absence, index) => (
        <ListItem
            key={absence.id}
            title={i18n.t(`absence.type.${absence.type}`)}
            tags={[absenceRange(new Date(absence.start), new Date(absence.end))]}
            description={absence.comment || ""}
            rightIcon="trash"
            rightActionMode="medium"
            rightIconColor={colors.primary}
            onDelete={() => onDeleteAbsenceAtIndex(index)}
            badge={
                <IconButton
                    onPress={() => onActionRemove(index)}
                    icon="trash"
                    size={20}
                    iconColor={colors.primary}
                    style={{ marginRight: marginSize / 2 }}
                />
            }
            style={{
                backgroundColor: colors.background,
            }}
            swipeableStyle={{
                marginHorizontal: -marginSize,
                borderRadius: 0,
            }}
        />
    ));
};

export default AbsenceList;
